class LuxuryFooter extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  connectedCallback() {
    this.backToTop = this.querySelector('[data-back-to-top]');
    if (this.backToTop) {
      this.backToTop.addEventListener('click', this.scrollToTop);
    }
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();
    this.initBrandSlider();
    this.initAccordions();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  initBrandSlider() {
    const slider = this.querySelector('[data-brand-slider]');
    const track = slider?.querySelector('.luxury-footer__brand-track');
    if (!track) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.style.animation = 'none';
    }
  }

  initAccordions() {
    const accordions = this.querySelectorAll('.luxury-footer__accordion');
    if (!accordions.length) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const syncAccordions = () => {
      accordions.forEach((accordion) => {
        if (mobileQuery.matches) {
          accordion.removeAttribute('open');
        } else {
          accordion.setAttribute('open', '');
        }
      });
    };

    syncAccordions();
    mobileQuery.addEventListener('change', syncAccordions);
  }

  onScroll() {
    if (!this.backToTop) return;
    this.backToTop.classList.toggle('is-visible', window.scrollY > 400);
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

if (!customElements.get('luxury-footer')) {
  customElements.define('luxury-footer', LuxuryFooter);
}
